export const LOG_ERROR_MESSAGE = {
  FETCH: '[LIF][Favorites][Fetch favorites]',
  ADD_TO_CART: '[LIF][Favorites][Add favorite to cart]',
}
